"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class InitialLoaderShelf {
    constructor() {
        this._loaded = false;
        mobx_1.makeObservable(this, {
            _loaded: mobx_1.observable,
            done: mobx_1.action,
            isLoaded: mobx_1.computed,
            isLoading: mobx_1.computed,
        });
    }
    done() {
        this._loaded = true;
    }
    get isLoaded() {
        return this._loaded;
    }
    get isLoading() {
        return !this.isLoaded;
    }
}
exports.default = InitialLoaderShelf;
